import React from 'react';
import './index.scss';
import Link from '@web-common/components/UI/Icons/svgs/Link';
class AttachmentIcon extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isShow: false,
            scrollDom: document.getElementById('writeMailEditorScroll'),
            attachmentListDom: {},
            contentObserver: {},
            scrollTimer: null,
        };
        this.bindHandleScroll = this.bindHandleScroll.bind(this);
        this.attachmentClick = this.attachmentClick.bind(this);
    }
    componentDidMount() {
        const { scrollDom } = this.state;
        this.setState({ attachmentListDom: document.querySelector('.attachment .attachment-list') });
        scrollDom.addEventListener('scroll', this.bindHandleScroll);
        this.createObserver();
    }
    componentWillUnmount() {
        const { scrollDom, contentObserver } = this.state;
        scrollDom.removeEventListener('scroll', this.bindHandleScroll);
        contentObserver.disconnect();
    }
    bindHandleScroll() {
        const { scrollDom, scrollTimer, attachmentListDom } = this.state;
        if (scrollTimer) {
            return;
        }
        this.setState({
            scrollTimer: setTimeout(() => {
                const num = scrollDom.getBoundingClientRect().bottom - attachmentListDom.getBoundingClientRect().top;
                if (num > 0) {
                    this.setState({ isShow: false });
                }
                else {
                    this.setState({ isShow: true });
                }
                this.setState({ scrollTimer: null });
            }, 100),
        });
    }
    createObserver() {
        const config = { childList: true, subtree: true };
        this.setState({ contentObserver: new MutationObserver(this.bindHandleScroll) }, () => {
            const { contentObserver, scrollDom } = this.state;
            contentObserver.observe(scrollDom, config);
        });
    }
    attachmentClick() {
        const { scrollDom } = this.state;
        const scrollTopDist = document.querySelectorAll('.editor-container')[0].getBoundingClientRect().height;
        scrollDom.scrollTo(0, scrollTopDist);
    }
    render() {
        const { isShow } = this.state;
        const { currentLength } = this.props;
        return (React.createElement("div", { className: "attachment-icon", style: { display: isShow ? 'flex' : 'none' }, onClick: this.attachmentClick },
            React.createElement(Link, { stroke: "#386EE7", width: "18px", height: "18px" }),
            React.createElement("span", null, currentLength)));
    }
}
export default AttachmentIcon;
